import { format } from 'date-fns';
import { StateCreator } from 'zustand';
import { CurrentTimeState } from './current_time_state';

const five_minute_interval = 1000 * 60 * 5;

export const createCurrentTimeState: StateCreator<CurrentTimeState> = (
  set,
  get
) => ({
  current_timers_started: false,
  current_day: format(new Date(), 'yyyy-MM-dd'),

  startTimers() {
    if (get().current_timers_started) return;

    const current_day_timer_id = setInterval(() => {
      set({
        current_day: format(new Date(), 'yyyy-MM-dd'),
      });
    }, five_minute_interval);

    set({
      current_day_timer_id,
    });
  },
});
